import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Snackbar
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

import PasswordResetSuccess from './PasswordResetSuccess';
import api from '../api/api';

const ForgotPassword = ({ onCancel }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/request-password-reset`, { email });
      setMessage(response.data.message);
      setAlertSeverity('success');
      setOpenSnackbar(true);
      setShowSuccess(true);
    } catch (error) {
      console.error('Error requesting password reset:', error);
      const errorMsg = error.response?.data?.message || t('passwordReset.error');
      setMessage(errorMsg);
      setAlertSeverity('error');
      setOpenSnackbar(true);
    }
  };

  if (showSuccess) {
    return <PasswordResetSuccess />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(3),
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography component="h1" variant="h5">
          {t('forgotPassword.title')}
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label={t('email')}
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t('forgotPassword.sendResetLink')}
          </Button>
          <Button
            fullWidth
            variant="text"
            color="primary"
            onClick={onCancel}
          >
            {t('cancel')}
          </Button>
        </Box>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={alertSeverity}
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ForgotPassword;